'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.default = ravenMiddle;

var _ravenJs = require('raven-js');

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _ravenForRedux = require('raven-for-redux');

var _ravenForRedux2 = _interopRequireDefault(_ravenForRedux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (_config2.default.sentryEnabled) {
  _ravenJs2.default.config(_config2.default.sentryDSN, {
    environment: _config2.default.sentryEnv
  }).install();
}
function flattenEntities(obj) {
  var keys = [];
  for (var key in obj) {
    if (key) {
      keys.push(key);
    }
  }
  return keys;
}
function ravenMiddle() {
  return (0, _ravenForRedux2.default)(_ravenJs2.default, {
    stateTransformer: function stateTransformer(state) {
      return (0, _assign2.default)({}, state, {
        entities: flattenEntities(state.entities)
      });
    },
    actionTransformer: function actionTransformer(action) {
      if (action.response && action.response.entities) {
        return (0, _assign2.default)({}, action, {
          response: (0, _assign2.default)({}, action.response, {
            entities: flattenEntities(action.response.entities)
          })
        });
      }
      return action;
    }
  });
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/middleware/ravenMiddleware.js
// module id = 1701
// module chunks = 0